module.exports = __webpack_public_path__ + "static/logo-raleigh-d2053996e8de9c37f9f2a4fb911f764f.jpg";